// 分类服务 - 适配实验室管理系统的API调用方式
const API_BASE = '/api';

// 辅助函数：获取token
const getToken = () => {
  return localStorage.getItem('token');
};

// 辅助函数：API请求
const apiRequest = async (url: string, options: RequestInit = {}) => {
  const token = getToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };
  
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE}${url}`, {
    ...options,
    headers,
  });

  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
      throw new Error('未授权，请重新登录');
    }
    const error = await response.json().catch(() => ({ message: '请求失败' }));
    throw new Error(error.message || '请求失败');
  }

  return response.json();
};

export interface Category {
  _id: string;
  name: string;
  userId: string;
  order: number;
  color: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCategoryData {
  name: string;
  color?: string;
}

export interface UpdateCategoryData {
  name?: string;
  color?: string;
  order?: number;
}

export const categoryService = {
  // 获取分类列表
  getList: async (): Promise<Category[]> => {
    try {
    const response = await apiRequest('/categories');
      // 处理不同的响应格式
      if (response.success && response.data && response.data.categories) {
        return Array.isArray(response.data.categories) ? response.data.categories : [];
      } else if (Array.isArray(response)) {
        return response;
      } else if (response.data && Array.isArray(response.data)) {
        return response.data;
      }
      return [];
    } catch (error) {
      console.error('获取分类列表失败:', error);
      return [];
    }
  },

  // 创建分类
  create: async (data: CreateCategoryData): Promise<Category> => {
    const response = await apiRequest('/categories', {
      method: 'POST',
      body: JSON.stringify(data),
    });
    return response.data.category;
  },

  // 更新分类
  update: async (id: string, data: UpdateCategoryData): Promise<Category> => {
    const response = await apiRequest(`/categories/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
    return response.data.category;
  },

  // 删除分类
  delete: async (id: string): Promise<void> => {
    await apiRequest(`/categories/${id}`, { method: 'DELETE' });
  },

  // 批量更新分类顺序
  updateOrders: async (orders: Array<{ id: string; order: number }>): Promise<void> => {
    await apiRequest('/categories/orders/update', {
      method: 'PUT',
      body: JSON.stringify({ orders }),
    });
  }
};
